import logo from './logo.svg';
import './App.css';
import Temp from './components/Temp';

function App() {
  return (
    <>
    <Temp/>
    </>
  );
}

export default App;
